import clsx from "clsx";
import React, { ReactNode } from "react";

const Tooltip = ({
  content,
  children,
  topOffset,
  leftOffset,
}: {
  content: ReactNode;
  children: ReactNode;
  topOffset: number;
  leftOffset: number;
}) => {
  return (
    <div className="group relative flex items-center">
      <div className="flex items-center gap-1">{children}</div>
      <div
        className={clsx(
          `absolute z-10 hidden rounded-md bg-white px-2 py-1 shadow-md group-hover:block`,
          "before:content-['']",
          "before:absolute",
          "before:-translate-x-1/2",
          "before:left-1/2",
          "before:top-full",
          "before:border-[10px]",
          "before:border-transparent",
          "before:border-t-white"
        )}
        style={{ top: `-${topOffset}px`, left: `-${leftOffset}px` }}
      >
        {content}
      </div>
    </div>
  );
};

export default Tooltip;
